// extracted by mini-css-extract-plugin
export default {"chat":"chat_chat__n8epr","collapsed":"chat_collapsed__CLDi4"};